import moment from 'moment';
import { English, Development } from './locale-context-provider/locale-codes';

const getLocaleForMoment = (locale) => {
  if (locale === Development) {
    return 'x-pseudo';
  }

  if (locale === English) {
    return null;
  }

  return locale.toLowerCase();
};

export const changeLocaleForMoment = (locale) => {
  const localeToUse = getLocaleForMoment(locale);
  if (!localeToUse) {
    moment.locale(locale);
    return;
  }

  import(`moment/locale/${localeToUse}.js`).then(() => {
    moment.locale(localeToUse);
  });
};
